import axios from 'axios';
import { BaseHttpClient } from '../BaseHttpClient';
import { injectCommonInterceptors } from '../interceptors';
import {
  CreateApiKeyPayload,
  CreateApiKeyResponse,
  ApiKeyResponse,
  DeleteApiKeyResponse,
} from './api.schema';
import { BASE_URL } from './consts';

const axiosApiKeysInstance = axios.create({
  baseURL: BASE_URL,
});

injectCommonInterceptors(axiosApiKeysInstance, {
  refreshToken: false,
});

export class ApiKeysClient extends BaseHttpClient {
  constructor() {
    super(axiosApiKeysInstance, {
      defaultExtractNestedData: false,
    });
  }

  // Singleton instance for access without instantiation
  static override instance = new ApiKeysClient();

  static async createApiKey(payload: CreateApiKeyPayload) {
    return await ApiKeysClient.post<CreateApiKeyResponse>('/', payload, {
      timeout: 8000,
    });
  }

  static async listApiKeys(includeDeleted = false) {
    return await ApiKeysClient.get<ApiKeyResponse[]>('/', {
      params: { include_deleted: includeDeleted },
    });
  }

  static async deleteApiKey(keyId: string) {
    return await ApiKeysClient.delete<DeleteApiKeyResponse>(`/${keyId}`);
  }
}
